/* 请求接口地址管理 */
export var IP = process.env.VUE_APP_BASE_URL